import React, { useMemo } from 'react'
import { useMount } from 'ahooks'
import Udb from '@yy/oneship-udb'
import { UDB_CONF } from '../constants'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from '../store'
import { useHistory } from 'react-router'
import { OneModal, OneNotification } from '@yy/one-ui'
import { IconExclamationCircle, Link } from '@yy/one-icon'
import { getOneClubPath } from '../utils'
import { Dialog, Toast } from 'antd-mobile'
import Cookies from 'js-cookie'
import { getBaseUserInfo } from '../store/authSlice'
import { check2fa } from '../services/api/bff/info/api'
import { useUserLogout } from './useUserLogout'
// 所有需要全局通知的都放这里

const pwdSafeUdb = Udb.pwdSafe(UDB_CONF)

/**
 * 密码有效期判断提示
 * @param notification
 */
const usePasswordExpiredNotif = (notification: (data: { url: string }) => void) => {
  const languageStore = useSelector((state) => state?.language)
  const userInfo = useSelector((state) => state.auth.userInfo)
  const uid = useMemo(() => Cookies.get('osudb_uid'), [])
  const dispatch = useDispatch()

  useMount(async () => {
    if (!uid) return
    // 通知提示
    const [pwdRes, user] = await Promise.all([pwdSafeUdb.queryPopup({ uid, ticketType: '1' }), userInfo ?? dispatch(getBaseUserInfo())])
    const day = Math.ceil(pwdRes.data.pwdRemainingTime / (24 * 3600 * 1000))

    if (day < 30 && ![30, 15, 7, 1].includes(day)) {
      const url = getOneClubPath('/user/changePassword', languageStore.lang, {
        email: user.udbUserInfo?.email,
        phone: user.udbUserInfo?.phone,
        source: user.registrySource || 'email',
        uid,
      })
      notification({ url })
    }
  })
}

/**
 * 密码有效期判断提示
 */
const usePcPasswordExpiredNotif = () => {
  const { t } = useTranslation()
  const history = useHistory()

  usePasswordExpiredNotif((data) => {
    OneNotification.warn({
      message: t('passwordExpired.noti.title'),
      description: (
        <>
          <div style={{ color: '#474F5E' }}>{t('passwordExpired.noti.desc')}</div>
          <div
            style={{
              color: '#356dff',
              fontSize: '14px',
              cursor: 'pointer',
              display: 'inline-block',
            }}
          >
            <span
              onClick={() => {
                history.push(data.url)
              }}
            >
              {t('update.password')}
              <Link style={{ marginLeft: 4 }} />
            </span>
          </div>
        </>
      ),
    })
  })
}

/**
 * 密码有效期判断提示
 */
const useMobilePasswordExpiredNotif = () => {
  const { t } = useTranslation()

  usePasswordExpiredNotif(() => {
    Toast.show(t('passwordExpired.noti.title'))
  })
}

const use2faNotif = (notification: () => void) => {
  const uid = useMemo(() => Cookies.get('osudb_uid'), [])
  useMount(async () => {
    if (!uid) return
    const res = await check2fa()
    // 没开启2fa并且账号要求开启
    if (!res.enabled && res.twoFactorAuthPolicy === 1) {
      notification()
    }
  })
}

const usePc2faNotif = () => {
  const { t } = useTranslation()
  const handleLogout = useUserLogout()
  use2faNotif(() => {
    OneModal.warn({
      title: t('login.please.relogin'),
      content: t('login.please.relogin.desc'),
      onOk: handleLogout,
      okText: t('go.login'),
      okButtonProps: {
        type: 'primary',
      },
      icon: <IconExclamationCircle className="anticon one-danger-modal-circle-icon" />,
    })
  })
}

const useMobile2faNotif = () => {
  const { t } = useTranslation()
  const handleLogout = useUserLogout()
  use2faNotif(() => {
    Dialog.alert({
      title: t('login.please.relogin'),
      content: t('login.please.relogin.desc'),
      onConfirm: handleLogout,
      confirmText: t('go.login'),
    })
  })
}

/**
 * pc所有全局提示
 */
export const usePcNotif = () => {
  usePcPasswordExpiredNotif()
  usePc2faNotif()
}

/**
 * h5所有全局提示
 */
export const useMobileNotif = () => {
  useMobilePasswordExpiredNotif()
  useMobile2faNotif()
}
